import { render, staticRenderFns } from "./TheTabBar.vue?vue&type=template&id=77027b91&scoped=true&"
import script from "./TheTabBar.vue?vue&type=script&lang=js&"
export * from "./TheTabBar.vue?vue&type=script&lang=js&"
import style0 from "./TheTabBar.vue?vue&type=style&index=0&id=77027b91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77027b91",
  null
  
)

export default component.exports